import { computed } from "@preact/signals-react";
import { useContext } from "react";
import { TimeUtils } from "../../utils";
import { AvisContext } from "../shared/context/AvisContext";
import { sessionTimeRemaining } from "./SessionStates";

export function SessionInfo() {
  const { res, ctxUser } = useContext(AvisContext);

  const timeRemaining = computed(() =>
    TimeUtils.millisecondsToHHMMSS(sessionTimeRemaining.value),
  );

  return (
    <li className="avis-session-info-menuitem">
      <div className="avis-session-info">{ctxUser?.name}</div>
      <div className="avis-session-info">
        {res("session_TillSessionExpiration")}
        <span>{timeRemaining.value}</span>
      </div>
    </li>
  );
}
